import { Component, OnInit } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
  selector: "app-flat-panel",
  templateUrl: "./flat-panel.component.html",
  styleUrls: ["./flat-panel.component.scss"],
})
export class FlatPanelComponent implements OnInit {
  display = false;
  selectedImage: string | null = null;

  constructor(private meta: Meta, private seoService: SeoServiceService) { }

  openImageModal(imageUrl: string) {
    this.selectedImage = imageUrl;
  }

  closeImageModal() {
    this.selectedImage = null;
  }

  play() {
    this.display = !this.display;
  }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.meta.addTag({
      name: "Description",
      content:
        "Virsa - Premium Interactive Flat Panel At affordable Price in Noida & Delhi NCR. For More Information  Send Inquiry & Reasonable Price. Get Discount On Order. Impeccable Quality.",
    });
  }

  features = [
    {
      image: "assets/images/digital/ifp/Ultra 4K UHD 21.jpg",
      title: "Ultra 4K UHD Smart Display for Classrooms",
      description:
        "Experience crystal-clear visuals with our Ultra 4K UHD Interactive Flat Panel, designed with anti-glare tempered glass for distraction-free learning in bright classrooms.",
      isList: false,
      reverse: false,
    },
    {
      image: "assets/images/digital/ifp/Dual Screen.jpg",
      title: "40-Point Multi-Touch Panel for Collaborative Learning",
      description:
        "Enable real-time group collaboration with up to 40-point multi-touch precision, perfect for interactive lessons, brainstorming sessions, and student engagement.",
      isList: false,
      reverse: true,
    },
    {
      image: "assets/images/digital/ifp/Classroom & Conference Ready.jpg",
      title: "Classroom & Conference Ready",
      description:
        "Equipped with essential teaching and meeting tools like a digital whiteboard suite, integrated cloud storage, screen recording, wireless casting, and pre-installed video conferencing apps such as Zoom, Teams, and Meet—perfect for both education and enterprise collaboration.",
      isList: false,
      reverse: false,
    },
    {
      image: "assets/images/digital/ifp/AI Powered.jpg",
      title: "AI-Powered Teaching Tools with Voice and Shape Recognition",
      description:
        "Leverage cutting-edge AI handwriting recognition, voice commands, and shape detection to deliver futuristic, hands-free, and intuitive classroom experiences.",
      isList: false,
      reverse: true,
    },
  ];

  educationFeatures = [
    {
      image: "assets/images/digital/ifp/education/edu-app.jpg",
      title: "Pre-Installed Educational Apps for K–12 Learning",
      description:
        "Access Math, Science, Coding, and Language apps directly from the smart panel, ready to support diverse curriculums and teaching methods.",
    },
    {
      image: "assets/images/digital/ifp/education/ocr.jpg",
      title: "AI-Powered Handwriting-to-Text Conversion",
      description:
        "Instantly convert handwritten notes into editable digital text, making smart lessons more interactive and efficient.",
    },
    // {
    //   image: "assets/images/digital/ifp/Dual Screen.jpg",
    //   title: "Real-Time Smart Annotation Across Any Content",
    //   description:
    //     "Annotate seamlessly over documents, browsers, or applications, enabling live interaction during presentations and lessons.",
    // },
    {
      image: "assets/images/digital/ifp/education/casting.jpg",
      title: "Wireless Screen Casting for Multi-Device Connectivity",
      description:
        "Easily cast content from mobile phones, tablets, and laptops (iOS, Android, Windows) to the Interactive Flat Panel without cables.",
    },
  ];

  iconFeatures = [
    { icon: '4k', title: '4K UHD Display', description: 'Ultra-high definition crystal clear visuals' },
    { icon: 'child_friendly', title: 'Child Safety & Eye-Safety Technology', description: 'Child safety & eye-safety technology' },
    { icon: 'touch_app', title: '40-point Touch', description: 'Multi-user simultaneous interaction' },
    { icon: 'devices', title: 'Dual OS', description: 'Android 14 + Windows OPS support' },
    { icon: 'edit', title: 'Intelligent Whiteboard', description: 'Exclusive  whiteboard adopting modern technology to accelerate classroom digitization.' },
    { icon: 'cloud', title: 'Air-Class', description: 'Wireless classroom management' },
    { icon: 'screen_share', title: 'Wireless Screen Share', description: 'Cast from any device seamlessly' },
    { icon: 'visibility', title: 'Anti-Glare Glass', description: 'Reduced eye strain & reflections' },
    { icon: 'usb', title: 'Type-C All-in-One Port', description: 'Single cable for power & data' },
    { icon: 'volume_up', title: 'Powerful Speakers', description: '2x20W premium audio output' },
    { icon: 'settings', title: 'Device Management System', description: 'Control & monitor smart devices' }
  ];

  galleryImages = [
    // 'assets/images/digital/ifp/1.jpg',
    // 'assets/images/digital/ifp/2.jpg',
    // 'assets/images/digital/ifp/3.jpg',
    // 'assets/images/digital/ifp/4.jpg',
    // 'assets/images/digital/ifp/6.jpg',
    'https://d3uop73ba1wtqg.cloudfront.net/uploads/b9I7wnRCuNjtP3KleOXGmDdn2nZ2CpTqpp8kLQ2R.jpg',
    'https://d3uop73ba1wtqg.cloudfront.net/uploads/aUyszNXuSylXNJmRunmJblyjaXrmIJWENt7RX3Cx.jpg',
    'https://d3uop73ba1wtqg.cloudfront.net/uploads/wPy7cPXs6LnwDQhw5mnGDtnaVrQwEuVZ7MXOFE2Y.jpg',
    'https://d3uop73ba1wtqg.cloudfront.net/uploads/mHOSe7y1imsPsXejTc0hMPtIX0ElIyAAX296Ch5a.jpg',
    'https://d3uop73ba1wtqg.cloudfront.net/uploads/RdVPiMbb9cn74bzBZSDL06ISVtpBpjMH6WVNbcrW.jpg',
    'https://d3uop73ba1wtqg.cloudfront.net/uploads/tFz4s8vauXPw0EyMzCpJXMZHQpZlm5qDQV6eY4ll.jpg',
    'https://d3uop73ba1wtqg.cloudfront.net/uploads/2aTgLlncC3m4KqIaXhWdk2gJDQ9ArzuOUkXftXER.jpg',
    'https://d3uop73ba1wtqg.cloudfront.net/uploads/zYipE0VFsqEWfXSEd6DWqO0OvndPVvnrL4F9Ky7u.jpg',

  ];

  modelSizes = ['55"', '65"', '75"', '86"', '98"', '105"', '110"'];
  selectedModel = '55"';

  selectModel(size: string) {
    this.selectedModel = size;
  }

  addOns = [
    {
      title: "Built-in Camera",
      description: "48MP AI-powered inbuilt camera with integrated microphone for clear video conferencing and hybrid learning.",
      icon: "camera_alt"
    },
    {
      title: "OPS (Open Pluggable Specification)",
      description: "Powerful computing modules with processor options: Intel i5 / i7 / i9.",
      icon: "memory"
    },
    // {
    //   title: "Memory Options",
    //   description: "RAM choices: 8 GB / 16 GB / 32 GB for smooth multitasking.",
    //   icon: "developer_board"
    // },
    {
      title: "Storage Options",
      description: "Expandable storage options : 256 GB / 512 GB  and above.",
      icon: "storage"
    },
    {
      title: "Movable Stand",
      description: "Sturdy and flexible stand options suitable for classrooms and office setups.",
      icon: "desktop_windows"
    },
    {
      title: "IFP Safety Shutters",
      description: "Durable protection solution for Interactive Flat Panels.",
      icon: "security"
    }
  ];

  accessories = [
    {
      title: "Remote Control",
      description: "Easy navigation and control from anywhere in the room.",
      icon: "settings_remote"
    },
    {
      title: "Stylus Interactive Pen",
      description: "High-precision ergonomic pens for natural writing usage.",
      icon: "edit"
    },
    {
      title: "Wall Mount",
      description: "Secure and durable wall mounting kit included.",
      icon: "tv"
    },
    {
      title: "Warranty Card",
      description: "Comprehensive warranty coverage for peace of mind.",
      icon: "card_membership"
    },
    {
      title: "Cables & Wires",
      description: "Complete set of cables and wires for setup (as applicable).",
      icon: "build"
    }
  ];

  useCases = [
    {
      subject: "Schools",
      description:
        "Transform traditional classrooms into modern smart learning spaces with interactive flat panels that support collaborative teaching.",
      image: "assets/images/smartroom/panel.jpg",
    },
    {
      subject: "Institute",
      description:
        "Deliver engaging lessons both in-person and online with hybrid teaching setups powered by our smart panels.",
      image: "assets/images/smartroom/panel.jpg",
    },
    {
      subject: "Corporate",
      description:
        "Upgrade boardrooms with interactive panels that boost team collaboration, idea sharing, and smart presentations.",
      image: "assets/images/smartroom/panel.jpg",
    },
    {
      subject: "Healthcare",
      description:
        "Enable dynamic, high-clarity presentations for medical education, diagnostics, and team consultations in healthcare environments.",
      image: "assets/images/smartroom/panel.jpg",
    },
    // {
    //   subject: "HR Training",
    //   description:
    //     "Enhance HR training, onboarding, and employee workshops with interactive smart panels for maximum engagement.",
    //   image: "assets/images/smartroom/panel.jpg",
    // },
  ];

  specSections = [
    {
      label: "Display Parameter",
      headerLabel: "Model",
      columns: ['Spec.', 'VIR55', 'VIR65', 'VIR75', 'VIR86', 'VIR98', 'VIR105', 'VIR110'],
      rows: [
        {
          label: "Resolution",
          values: ["3840*2160/UHD", "✔", "✔", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "Aspect Ratio",
          values: ["16:9", "✔", "✔", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "Contrast Ratio",
          values: ["4000:1 / 5000:1", "✔", "✔", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "Colors",
          values: ["1.07 billion colors", "✔", "✔", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "Brightness",
          values: ["450 cd/m2", "350 cd/m2", "✔", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "Viewing Angle",
          values: ["178°", "✔", "✔", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "Screen Surface",
          values: [
            "4 mm thickness Anti-Glare glass",
            "✔", "✔", "✔", "✔", "✔", "✔", "✔",
          ],
        },
      ],
    },
    {
      label: "Panel Interactivity",
      headerLabel: "Model",
      columns: ['Spec.', 'VIR55', 'VIR65', 'VIR75', 'VIR86', 'VIR98', 'VIR105', 'VIR110'],
      rows: [
        {
          label: "Touch Technology",
          values: ["IR Touch", "✔", "✔", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "Touch Points",
          values: [
            "40 point (Win 7/8/10)\n20 points touch (Android)",
            "✔", "✔", "✔", "✔", "✔", "✔", "✔",
          ],
        },
        {
          label: "Touch Accuracy",
          values: ["± 2mm (Windows)", "± 1mm", "✔", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "Recognition",
          values: [
            "Finger or passive stylus",
            "✔", "✔", "✔", "✔", "✔", "✔", "✔",
          ],
        },
        {
          label: "Response Rate",
          values: [
            "<4 ms (single touch)\n<10 ms (max touch inputs)",
            "✔", "✔", "✔", "✔", "✔", "✔", "✔",
          ],
        },
        {
          label: "Response Rate",
          values: ["2mm", "✔", "✔", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "Response Time",
          values: ["<5ms", "<8ms", "<8ms", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "Hotspot",
          values: ["Yes", "✔", "✔", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "Bluetooth",
          values: ["V 5.0", "✔", "✔", "✔", "✔", "✔", "✔", "✔"],
        },
        {
          label: "WiFi",
          values: [
            "Version 802.11 ac/b/g/n/a/ax &\nworking frequency 2.4 GHz/5 GHz",
            "✔", "✔", "✔", "✔", "✔", "✔", "✔",
          ],
        },
      ],
    },
    {
      label: "Back Side Connectivity",
      headerLabel: "Model",
      columns: ['Spec.', 'VIR55', 'VIR65', 'VIR75', 'VIR86', 'VIR98', 'VIR105', 'VIR110'],
      rows: [
        {
          label: "I/O Interface",
          values: [
            "RJ45 * 2\nRS232 * 1\nVGA * 1\nPC AUDIO IN * 1\nTOUCH USB 2.0 * 2\nOPTICAL OUT * 1\nTF CARD * 1\n(Mini) MIC IN * 1\n(Mini) LINE OUT * 1\nUSB 3.0 * 1\nUSB 2.0 * 1\nHDMI IN * 2\nDP IN * 1\nType-C * 1",
            "✔", "✔", "✔", "✔", "✔", "✔", "✔"
          ]
        },
        {
          label: "Front Interface",
          values: [
            "USB 3.0 * 2\nTOUCH USB * 1 (USB2.0)\nHDMI IN * 1 (HDMI 2.0)\nType C * 1",
            "✔", "✔", "✔", "✔", "✔", "✔", "✔"
          ]
        },
        { label: "Speaker", values: ["", "15W*2", "20W*2", "20W*2", "20W*2", "20W*2", "20W*2", "20W*2"] },
      ],
    },
    {
      label: "Operating System",
      headerLabel: "Model",
      columns: ['Spec.', 'VIR55', 'VIR65', 'VIR75', 'VIR86', 'VIR98', 'VIR105', 'VIR110'],
      rows: [
        { label: "Android Version", values: ["Android 14.0", "✔", "✔", "✔", "✔", "✔", "✔", "✔"] },
        { label: "Chipset", values: ["9679 Chipset A73*4", "✔", "✔", "✔", "✔", "✔", "✔", "✔"] },
        { label: "CPU", values: ["Quad Core / Octa Core", "✔", "✔", "✔", "✔", "✔", "✔", "✔"] },
        { label: "GPU", values: ["G52", "✔", "✔", "✔", "✔", "✔", "✔", "✔"] },
        { label: "RAM", values: ["8GB / 16GB System Memory", "✔", "✔", "✔", "✔", "✔", "✔", "✔"] },
        { label: "ROM", values: ["128GB to Infinite System Storage", "✔", "✔", "✔", "✔", "✔", "✔", "✔"] },
        { label: "Compliant With", values: ["Windows, Mac, Linux, Chrome OS", "✔", "✔", "✔", "✔", "✔", "✔", "✔"] },
        { label: "Gross Weight", values: ["(Kg ± 2)", "52", "56", "68", "98", "115.3", "116.1", "194"] },
        { label: "Bare Dimension (mm)*", values: ["(L*H*W)", "1258 * 770.5 * 83.4", "1483.4 * 896.6 * 87.2", "1705.4 * 1015.8 * 102.7", "1951.6 * 1154.4 * 102.7", "2215.8 * 1322.7 * 106", "2507.2 * 1130.1 * 103.2", "2507.1 * 1474.8 * 96.8"] },
        { label: "Packing Dimension (mm)*", values: ["(L*H*W)", "1371.6 * 889 * 177.8", "1630 * 1050 * 220", "1850 * 1167 * 215", "2090 * 1300 * 215", "2235.8 * 1342.7 * 142", "2668 * 1305 * 280", "2685 * 1630 * 310"] },
        { label: "Input Voltage", values: ["100-240V (50/60hz 4A)", "✔", "✔", "✔", "✔", "✔", "✔", "✔"] },
        { label: "Power Consumption", values: ["", "Max 280W", "Max 280W", "Max 350W", "Max 450W", "Max 650W", "Max 750W", "Max 750W"] },
        { label: "Updates", values: ["2 Years OTA Updates", "✔", "✔", "✔", "✔", "✔", "✔", "✔"] },
        { label: "Camera & Mic", values: ["48 Megapixel Camera and 8 Array Mic (Optional)", "", "✔", "✔", "✔", "✔", "✔", "✔"] },
        { label: "AI", values: ["In-built AI", "✔", "✔", "✔", "✔", "✔", "✔", "✔"] }
      ]
    }
  ];
}
